/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./ButtonGroup.scss";

export interface IButtonGroupProps {
	className?: string;
}

export const ButtonGroup: React.FC<IButtonGroupProps> = ({ className, children }) => {
	const baseClass = BEM("edt-button-group");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
